module.exports = __webpack_public_path__ + "img/allied_tank.70c14e08.webp";